import React from 'react'

import scrollTo from 'gatsby-plugin-smoothscroll'
import { string, object } from 'prop-types'

import Icon from '../Icon'
import Title from '../Title'
import * as S from './styled'

const CardIcon = ({ color, icon, title, afterTitle, action, ...rest }) => (
  <S.CardIconWrapper {...rest}>
    <Icon name={icon} color={color} size={90} />
    <Title
      appearance="card-icon"
      marginTop={16}
      marginBottom={16}
      color={color}
      afterTitle={afterTitle}
    >
      {title}
    </Title>
    {action && (
      <S.CardIconButton
        onClick={() => scrollTo(action.to)}
        title={action.label}
        color={action.color}
      >
        {action.label}
      </S.CardIconButton>
    )}
  </S.CardIconWrapper>
)

CardIcon.defaultProps = {
  color: 'primary',
}

CardIcon.propTypes = {
  color: string,
  icon: string,
  title: string,
  afterTitle: string,
  action: object,
}

export default CardIcon
